export const FTPS = "FTPS";
export const HTTPS = "HTTPS";
export const OTA = "OTA";
export const LICENSE = "LICENSE";
